module.exports = __webpack_public_path__ + "static/media/brands_GRUNDFOS.fe083025.svg";